import { render, staticRenderFns } from "./myRanking.vue?vue&type=template&id=28752656&scoped=true"
import script from "./myRanking.vue?vue&type=script&lang=js"
export * from "./myRanking.vue?vue&type=script&lang=js"
import style0 from "./myRanking.vue?vue&type=style&index=0&id=28752656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28752656",
  null
  
)

export default component.exports